import { render } from "./hostTopicInfo.vue?vue&type=template&id=7b5e0dd5&scoped=true"
import script from "./hostTopicInfo.vue?vue&type=script&lang=js"
export * from "./hostTopicInfo.vue?vue&type=script&lang=js"

import "./hostTopicInfo.vue?vue&type=style&index=0&id=7b5e0dd5&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b5e0dd5"]])

export default __exports__